<template>
  <Card class="calendar">
    <div class="calendar-header">
      {{ selectedDate.format('MMMM YYYY') }}
      <div class="calendar-pagination">
        <Icon name="chevron-left" @click="prevMonth"></Icon>
        <Icon name="chevron-right" @click="nextMonth"></Icon>
      </div>
    </div>
    <div class="calendar-content">
      <div class="calendar-weekdays">
        <div class="calendar-weekday" v-for="(day, index) in weekdays" :key="index">{{ $t(day) }}</div>
      </div>
      <div class="calendar-days">
        <CalendarDay v-for="(day, index) in days" :key="index" :day="day" :today="selectedDate" @selectDay="selectDay" />
      </div>

      <div v-if="!monthHasEvents" class="calendar-outline">
        <div class="calendar-banner">
          <p>Geen beschikbare sessies in {{ selectedDate.format('MMMM') }}</p>
          <a class="banner-link" href="#" @click="goToNextSession" ><span>Bekijk eerstvolgende sessie <Icon name="chevron-right" /></span></a>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import Icon from '../Core/Icon'
import Card from '../Core/Card'
import CalendarDay from './CalendarDay'
export default {
  name: 'Calendar',
  components: {
    CalendarDay,
    Card,
    Icon
  },
  props: {
    events: Array,
    showNextEvent: Boolean
  },
  data () {
    return {
      selectedDate: this.$moment(),
      weekdays: ['ma', 'di', 'wo', 'do', 'vr', 'za', 'zo']
    }
  },
  mounted () {
    if (this.showNextEvent) this.nextEvent()
    if (this.$route?.query?.date) {
      const date = this.$moment.unix(this.$route.query.date)
      const day = this.days.find(day => {
        return day.date.isSame(date)
      })
      this.selectedDate = day.date
      this.$emit('input', day)
    }
  },
  methods: {
    prevMonth () {
      this.selectedDate = this.$moment(this.selectedDate).subtract(1, 'month')
    },
    nextMonth () {
      this.selectedDate = this.$moment(this.selectedDate).add(1, 'month')
    },
    selectDay (day) {
      this.selectedDate = day.date
      this.$emit('input', day)
    },
    nextEvent () {
      const today = this.$moment()
      for (let i = 0; i < this.events.length; i++){
        let event = this.events[i]
        if (event.date.isSame(today) || event.date.isAfter(today)) {
          this.selectedDate = event.date
          break;
        }
      }
    },
    goToNextSession (e) {
      e.preventDefault()
      this.nextEvent()
    }
  },
  computed: {
    days () {
      const date = this.selectedDate
      const startOfMonth = date.clone().startOf('month')
      const startDayOfMonth = parseInt(startOfMonth.format('d'))
      const firstMonday = startOfMonth.clone().subtract((startDayOfMonth ? (startDayOfMonth - 1) : 6), 'day')
      const endOfMonth = date.clone().endOf('month')
      const lastDayOfMonth = parseInt(endOfMonth.format('d'))
      const lastSunday = endOfMonth.clone().add(7 - lastDayOfMonth, 'day')

      const days = []
      for (let i = 0; i < lastSunday.diff(firstMonday, 'days'); i++) {
        const date = firstMonday.clone().add(i, 'day')

        // Filter reservations that match this date
        const reservations = this.events.filter(reservation => {
          return reservation.date.isSame(date, 'day')
        })

        days.push({
          date,
          events: reservations
        })
      }
      return days
    },
    monthHasEvents () {
      return this.events.find((event) => event.date.isSame(this.selectedDate, 'months'))
    }
  }
}
</script>

<style lang="scss">
.calendar-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  z-index: 10;
  position: relative;
}
.calendar-pagination i {
  cursor: pointer;
  padding: 1rem;
}
.calendar-weekdays,
.calendar-days {
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(7, 1fr);
}
.calendar-weekdays {
  color: var(--gray-darker);
  margin-bottom: 1rem;
}
.calendar-weekday {
  text-align: center;
  width: 40px;
  height: 40px;
}
@media screen and (max-width: 768px) {
  .calendar {
    padding: 0 !important;
    border: 0 !important;
    font-size: 80%;

    .calendar-weekdays,
    .calendar-days {
      grid-gap: 0.5rem;
    }

    .calendar-weekday,
    .calendar-day {
      width: 30px;
      height: 30px;
    }
  }
}
.calendar-content {
  position: relative;
}
.calendar-outline {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.calendar-banner {
  padding: 0.8rem 1.25rem;
  border-radius: 3rem;
  box-shadow: 1px 0px 4px 1px #ababab;
  background-color: white;
  text-align: center;
}
.calendar p {
  margin-bottom: 0.3rem;
}
.banner-link {
  font-size: 18px;
}
.banner-link .icon {
  margin-left:6px;
  font-size: 1rem;
}
</style>
